module.exports = __webpack_public_path__ + "img/GoldenRoseCC_DG.a5cfcd49.jpg";